import { DataRow } from '../types/components/data-rendering'
import { computed, Ref } from 'vue'
import { isValidDate } from '../utils'
import { format } from 'date-fns'

export function useGroup(data: Ref<DataRow[]>, grouping: Ref<string | null>) {
  const groupData = (data: any[], grouping: string, groupBy: string | null) => {
    const acc = []
    for (let index = 0; index < data.length; index++) {
      const row = data[index]
      if (row[grouping] === groupBy) {
        acc.push({ _index: acc.length, _group: groupBy, ...row })
      }
    }
    return acc
  }

  const groupDataHashMap = computed(() => {
    if (!grouping.value) return data.value
    const acc: any = {}
    for (let index = 0; index < data.value.length; index++) {
      const row = data.value[index]
      if (!acc[row[grouping.value]]) {
        acc[row[grouping.value]] = []
      }
      acc[row[grouping.value]].push({
        ...row,
        //keep down here to rename index
        _index: acc[row[grouping.value]].length,
        _group: [String(row[grouping.value])],
      })
    }
    return acc
  })

  // The headings of the tables after grouping is applied
  const groupedDataHeadings: Ref<string[]> = computed(() => {
    if (grouping.value !== null) {
      return Object.keys(groupDataHashMap.value).sort()
      return Object.keys(groupDataHashMap.value).sort((a, b) => {
        a = isValidDate(a) ? format(new Date(a), 'yyyyMMdd') : a
        b = isValidDate(b) ? format(new Date(b), 'yyyyMMdd') : b
        return ('' + a).localeCompare('' + b, undefined, { numeric: true })
      })
    } else {
      return []
    }
  })

  return {
    groupData: groupData,
    groupDataHashMap,
    groupedDataHeadings,
  }
}
